import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { addCart } from "../../Redux/Product/action";

export default function ProductContainer() {
  const { products } = useSelector((state) => state.product);
  const dispatch = useDispatch();

  //   console.log("productList:: ", productList);
  //   HANDLE FUNCTION START
  const handleAddCart = (product) => {
    dispatch(addCart(product));
  };
  //   HANDLE FUNCTION END
  return (
    <>
      {/* <!-- products container --> */}
      <div className="productContainer" id="lws-productContainer">
        {products.length > 0 ? (
          <>
            {products.map((product, index) => (
              <div key={`${product?.id}_${index}`} className="lws-productCard">
                <img
                  className="lws-productImage"
                  src={product?.imageUrl}
                  alt="product"
                />
                <div className="p-4 space-y-2">
                  <h4 className="lws-productName">{product?.productName}</h4>
                  <p className="lws-productCategory">{product?.category}</p>
                  <div className="flex items-center justify-between pb-2">
                    <p className="productPrice">
                      BDT <span className="lws-price">{product?.price}</span>
                    </p>
                    <p className="productQuantity">
                      QTY{" "}
                      <span className="lws-quantity">{product?.quantity}</span>
                    </p>
                  </div>
                  <button
                    onClick={() => handleAddCart(product)}
                    className="lws-btnAddToCart"
                    disabled={product?.quantity === 0 && true}
                  >
                    Add To Cart
                  </button>
                </div>
              </div>
            ))}
          </>
        ) : (
          <div>No Product Found</div>
        )}
      </div>
      {/* <!-- products container ends --> */}
    </>
  );
}
